export const formatPhone = (num) => num != null && (num.startsWith("8") ? num.replace("8", "+7") : num);
